import { MoreVertical } from 'lucide-react'
import type * as React from 'react'

import { Button } from './clickable'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from './DropdownMenu'

interface ActionsMenuProps {
  children: React.ReactNode
}

const ActionsMenu: React.FC<ActionsMenuProps> = ({ children }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button theme="outline" size="sm" className="gap-1.5">
          <MoreVertical className="h-4 w-4" />
          Actions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">{children}</DropdownMenuContent>
    </DropdownMenu>
  )
}
ActionsMenu.displayName = 'ActionsMenu'

export { ActionsMenu }
